module.exports = __webpack_public_path__ + "img/outlined-hawkgirl.9c0f7c19.png";